'use client';
import getHostApiOnline from 'eco-design-reliance/api-host';
import { getSignHeaders, getUploadAuthHeaders } from './config';

export type UploadableFile = Blob & { name?: string; type?: string };

/**
 * 与 Uploader 组件相同的 signed URL 上传逻辑（替代存在安全漏洞的 stsServer）
 * @returns 上传成功后的可访问 url
 */
export async function uploadFile(file: UploadableFile, locale = 'us'): Promise<string> {
    const currentApi = getHostApiOnline(locale)?.NEXT_PUBLIC_LOGIN_HOST;

    const contentType = file.type || 'application/octet-stream';
    const fileName = file.name || `file-${Date.now()}`;
    const authHeaders = getUploadAuthHeaders();
    const isLogin = !!authHeaders?.Authorization;
    const baseAPI = `/system/oss/signed/upload${isLogin ? '' : '/v2'}`;
    const uploadUrl = `${currentApi}${baseAPI}?contentType=${contentType}&scene=WEBSITE&file=${encodeURIComponent(fileName)}`;
    const signHeaders = getSignHeaders('GET', uploadUrl);

    const response = await fetch(uploadUrl, {
        method: 'GET',
        headers: isLogin
            ? {
                  ...authHeaders,
                  ...signHeaders,
              }
            : {},
    });

    const result = await response.json();
    const signedUrl = result?.data?.signedUrl;
    const url = result?.data?.url;

    if (!response.ok || result?.code !== '0' || !signedUrl || !url) {
        throw new Error(result?.message || 'Upload response missing signed URL');
    }

    const uploadResponse = await fetch(signedUrl, {
        method: 'PUT',
        headers: {
            'Content-Type': contentType,
        },
        body: file,
    });

    if (!uploadResponse.ok) {
        throw new Error(`Upload failed with status ${uploadResponse.status}`);
    }

    return url as string;
}
